/**
 * @generated SignedSource<<bbb140385098c103478f939df4c8ae1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SageSyncAnalysisPage_viewer$data = {
  readonly id: string;
  readonly missionControlData: {
    readonly companySyncAnalysis: {
      readonly id: string;
      readonly companyId: number;
      readonly companyName: string;
    } | null;
    readonly companySyncAnalysisHistory: ReadonlyArray<{
      readonly id: string;
      readonly forecastCompanyId: number;
      readonly syncDate: number;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
  readonly " $fragmentType": "SageSyncAnalysisPage_viewer";
};
export type SageSyncAnalysisPage_viewer$key = {
  readonly " $data"?: SageSyncAnalysisPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SageSyncAnalysisPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "companyId",
  "variableName": "companyId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "analysisId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "companyId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forceRefresh"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SageSyncAnalysisPage_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MissionControlHeader_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "analysisId",
              "variableName": "analysisId"
            },
            (v1/*: any*/),
            {
              "kind": "Variable",
              "name": "forceRefresh",
              "variableName": "forceRefresh"
            }
          ],
          "concreteType": "MissionControlSageSyncAnalysisType",
          "kind": "LinkedField",
          "name": "companySyncAnalysis",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v1/*: any*/)
          ],
          "concreteType": "MissionControlSageSyncAnalysisHistoryType",
          "kind": "LinkedField",
          "name": "companySyncAnalysisHistory",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastCompanyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "f0507b07743d31b146c845206a295435";

export default node;
